import { SET_URLS } from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_URLS:
      return action.payload;
    default:
      return state;
  }
};
